import React from "react";
import logo from "../../assets/images/logo/hv1.svg";

export const Footer = () => {
  return (
    <footer className="footer-modern bg-primary text-white font-futura mt-12">
      <div className="container mx-auto px-4 py-12 rounded-2xl shadow-lg flex flex-col md:flex-row md:items-start md:gap-8 footer-block-container-modern">
        {/* Logo and Brand */}
        <div className="md:w-1/5 mb-8 md:mb-0 flex flex-col items-start justify-start">
          <img src={logo} alt="logo" className="h-12 mb-4" />
          <span className="text-sm text-light-green">&copy; {new Date().getFullYear()} Halyavara. All rights reserved.</span>
        </div>
        {/* Footer Links */}
        <div className="flex-1 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-6">
          <div>
            <h4 className="text-lg font-bold mb-3" style={{ color: '#fff' }}>Product</h4>
            <ul className="space-y-2">
              <li><a href="#features" className="footer-link-modern">Features</a></li>
              <li><a href="#pricing" className="footer-link-modern">Pricing</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-lg font-bold mb-3" style={{ color: '#fff' }}>Resources</h4>
            <ul className="space-y-2">
              <li><a href="./blog" className="footer-link-modern">Blog</a></li>
              <li><a href="#user-guides" className="footer-link-modern">User Guides</a></li>
              <li><a href="#webinar" className="footer-link-modern">Webinar</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-lg font-bold mb-3" style={{ color: '#fff' }}>Community</h4>
            <ul className="space-y-2">
              <li><a href="#developers" className="footer-link-modern">Developers</a></li>
              <li><a href="#users" className="footer-link-modern">Users</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-lg font-bold mb-3" style={{ color: '#fff' }}>Company</h4>
            <ul className="space-y-2">
              <li><a href="./about" className="footer-link-modern">About</a></li>
              <li><a href="./contact-us" className="footer-link-modern">Join Us</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-lg font-bold mb-3" style={{ color: '#fff' }}>Support</h4>
            <ul className="space-y-2">
              <li><a href="./contact-us" className="footer-link-modern">Help Center</a></li>
              <li><a href="./chat-support" className="footer-link-modern">Chat Support</a></li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};



